function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { CheckIcon, ChevronRightIcon, CircleIcon } from 'lucide-react';
import * as React from 'react';
import { cn } from '../../lib/utils';
function DropdownMenu(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(DropdownMenuPrimitive.Root, _object_spread({
        modal: false,
        "data-slot": "dropdown-menu"
    }, props));
}
function DropdownMenuPortal(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(DropdownMenuPrimitive.Portal, _object_spread({
        "data-slot": "dropdown-menu-portal"
    }, props));
}
const DropdownMenuTrigger = /*#__PURE__*/ React.forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, {} = _ref1, props = _extends({}, _ref1), [ref] = _rest;
    return /*#__PURE__*/ _jsx(DropdownMenuPrimitive.Trigger, _object_spread({
        ref: ref,
        "data-slot": "dropdown-menu-trigger"
    }, props));
});
DropdownMenuTrigger.displayName = DropdownMenuPrimitive.Trigger.displayName;
function DropdownMenuContent(_0) {
    let { className, sideOffset = 4, container } = _0, props = _object_without_properties(_0, [
        "className",
        "sideOffset",
        "container"
    ]);
    return /*#__PURE__*/ _jsx(DropdownMenuPrimitive.Portal, {
        container: container,
        children: /*#__PURE__*/ _jsx(DropdownMenuPrimitive.Content, _object_spread({
            "data-slot": "dropdown-menu-content",
            sideOffset: sideOffset,
            className: cn('z-50 min-w-32 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md', 'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95', 'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2', className)
        }, props))
    });
}
function DropdownMenuGroup(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(DropdownMenuPrimitive.Group, _object_spread({
        "data-slot": "dropdown-menu-group"
    }, props));
}
function DropdownMenuItem(_0) {
    let { className, inset, variant = 'default' } = _0, props = _object_without_properties(_0, [
        "className",
        "inset",
        "variant"
    ]);
    return /*#__PURE__*/ _jsx(DropdownMenuPrimitive.Item, _object_spread({
        "data-slot": "dropdown-menu-item",
        "data-inset": inset,
        "data-variant": variant,
        className: cn("text-foreground hover:text-purple-400 no-underline focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className)
    }, props));
}
function DropdownMenuCheckboxItem(_0) {
    let { className, children, checked } = _0, props = _object_without_properties(_0, [
        "className",
        "children",
        "checked"
    ]);
    return /*#__PURE__*/ _jsxs(DropdownMenuPrimitive.CheckboxItem, _object_spread_props(_object_spread({
        "data-slot": "dropdown-menu-checkbox-item",
        className: cn("focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className),
        checked: checked
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center",
                children: /*#__PURE__*/ _jsx(DropdownMenuPrimitive.ItemIndicator, {
                    children: /*#__PURE__*/ _jsx(CheckIcon, {
                        className: "size-4"
                    })
                })
            }),
            children
        ]
    }));
}
function DropdownMenuRadioGroup(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(DropdownMenuPrimitive.RadioGroup, _object_spread({
        "data-slot": "dropdown-menu-radio-group"
    }, props));
}
function DropdownMenuRadioItem(_0) {
    let { className, children } = _0, props = _object_without_properties(_0, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(DropdownMenuPrimitive.RadioItem, _object_spread_props(_object_spread({
        "data-slot": "dropdown-menu-radio-item",
        className: cn("focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className)
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center",
                children: /*#__PURE__*/ _jsx(DropdownMenuPrimitive.ItemIndicator, {
                    children: /*#__PURE__*/ _jsx(CircleIcon, {
                        className: "size-2 fill-current"
                    })
                })
            }),
            children
        ]
    }));
}
function DropdownMenuLabel(_0) {
    let { className, inset } = _0, props = _object_without_properties(_0, [
        "className",
        "inset"
    ]);
    return /*#__PURE__*/ _jsx(DropdownMenuPrimitive.Label, _object_spread({
        "data-slot": "dropdown-menu-label",
        "data-inset": inset,
        className: cn('px-2 py-1.5 text-sm font-medium data-[inset]:pl-8', className)
    }, props));
}
function DropdownMenuSeparator(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(DropdownMenuPrimitive.Separator, _object_spread({
        "data-slot": "dropdown-menu-separator",
        className: cn('bg-border -mx-1 my-1 h-px', className)
    }, props));
}
function DropdownMenuShortcut(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("span", _object_spread({
        "data-slot": "dropdown-menu-shortcut",
        className: cn('text-muted-foreground ml-auto text-xs tracking-widest', className)
    }, props));
}
function DropdownMenuSub(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(DropdownMenuPrimitive.Sub, _object_spread({
        "data-slot": "dropdown-menu-sub"
    }, props));
}
function DropdownMenuSubTrigger(_0) {
    let { className, inset, children } = _0, props = _object_without_properties(_0, [
        "className",
        "inset",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(DropdownMenuPrimitive.SubTrigger, _object_spread_props(_object_spread({
        "data-slot": "dropdown-menu-sub-trigger",
        "data-inset": inset,
        className: cn('focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground flex cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[inset]:pl-8', className)
    }, props), {
        children: [
            children,
            /*#__PURE__*/ _jsx(ChevronRightIcon, {
                className: "ml-auto size-4"
            })
        ]
    }));
}
function DropdownMenuSubContent(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(DropdownMenuPrimitive.SubContent, _object_spread({
        "data-slot": "dropdown-menu-sub-content",
        className: cn('z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2', className)
    }, props));
}
export { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuShortcut, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger };
